// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "services-3XxyF";
var _5 = "hidden-S6j8k";
var _6 = "bookingAncillaries__root-2aATk";
var _7 = "bookingAncillaries__item-364kn";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "services", _5 as "hidden", _6 as "bookingAncillaries__root", _7 as "bookingAncillaries__item" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "services": _4, "hidden": _5, "bookingAncillaries__root": _6, "bookingAncillaries__item": _7 }
